<script>
import { flow, get } from 'lodash/fp'
import { mapGetters, mapActions } from 'vuex'
import TreeBranch from './TreeBranch'// eslint-disable-line
import DeleteModal from '@/components/DeleteModal'// eslint-disable-line
import sort from '@/sorts'

export default {
  name: 'TreeBranch',
  props: {
    search: String,
    dense: {
      type: Boolean,
      default: false
    },
    headers: Array,
    type: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    parents: {
      type: Array,
      default () {
        return []
      }
    },
    collapseAll: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default () {
        return {
          descending: false,
          sortBy: null
        }
      }
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      children: [],
      searchMatch: true,
      hasChildSearchMatch: false,
      open: false,
      deleteDialog: false,
      deleteChildrenOnly: false,
      loading: false,
      showInput: false,
      newName: '',
      newCount: 0,
      showNewChildInput: false,
      newChild: 'New Type',
      init: false,
      subscribed: false
    }
  },
  created () {
    // console.log('\n\n ~~~~~ CREATED TreeBranch ~~~~~~~~~')
    // console.log('this.ref: ', this.ref)
    if ((this.open && this.isFolder) || this.type.root) this.getChildren()
  },
  computed: {
    isSelected () {
      return this.$store.getters['standardItems/itemTypes/selectedID'] === this.type.id
    },
    deepSearchMatch () {
      return this.searchMatch || this.hasChildSearchMatch
    },
    iconBtnClasses () {
      return this.dense
        ? {
          'mx-0': true,
          'my-0': true
        } : {}
    },
    sortedChildren () {
      return this.pagination.sortBy
        ? sort(
          this.children,
          this.pagination.sortBy,
          this.pagination.descending,
          this.headers
        )
        : this.children
    },
    isFolder () {
      return this.typeHasChildren(this.type.id)
    },
    parentsForChildren () {
      return [ ...this.parents, this.type ]
    },
    itemCount () {
      return flow([
        this.getItemType,
        get('itemCount')
      ])(this.type.id)
    },
    routeToItems () {
      return !this.isFolder
        ? `/standard-items/${this.type.id}/items`
        : `/standard-items/${this.type.id}`
    },
    ...mapGetters('standardItems/itemTypes', {
      getItemType: 'itemType',
      typeHasChildren: 'children/typeHasChildren',
      getChildrenForType: 'getTypeChildren'
    })
  },
  watch: {
    search (newValue, oldValue) {
      this.hasChildSearchMatch = false

      if (!this.subscribed) this.getChildren()

      let result = false
      if (newValue && newValue.length) {
        result = this.type.name.toLowerCase().includes(newValue.toLowerCase()) || this.hasChildSearchMatch
        if (result) {
          console.log('search watch, match for type: ', this.type.name)
          this.$emit('searchMatch')
        }
      } else {
        result = true
      }
      this.searchMatch = result
    },
    hasChildSearchMatch (newValue, oldValue) {
      if (newValue) {
        this.$emit('searchMatch')
      }
    },
    open (newValue, oldValue) {
      /*
      console.log('watch open toggled: ')
      console.log('newValue', newValue)
      console.log('oldValue', oldValue)
      */
      if (newValue && this.isFolder) {
        this.update()
      }
    },
    expandAll (newValue, oldValue) {
      if (newValue) this.open = true
    },
    collapseAll (newValue, oldValue) {
      if (newValue) this.open = false
    }
  },
  methods: {
    branchCheckboxChanged (e) {
      console.log('branchCheckboxChanged', e)
      this.updateSelected(this.type.id)
    },

    childSearchMatch () {
      console.log('heard child emit search-match in type: ', this.type.name)
      this.hasChildSearchMatch = true
      this.open = true
    },
    inputNewName (event) {
      // console.log('INPUT NEW NAME')
      // console.log('event: ', event)
      this.newName = event
    },
    updateNameKeyInput (e) {
      // console.log('updateNameKeyInput', e)
      // Abort if the element emitting the event is not
      // the element the event is bound to
      if (e.target !== e.currentTarget) return
      if (e.keyCode !== 13) return

      this.saveEdit(e)
    },
    update () {
      this.getChildren()
    },
    getChildren () {
      console.log('GETTING CHILDREN FOR TreeBranch', this.type.name, this.type.id)
      const children = this.getChildrenForType(this.type.id)
      console.log('children: ', children)
      this.children = children
      this.subscribeToChildren()
    },
    subscribeToChildren () {
      if (this.subscribed) return

      this.$store.subscribe((mutation, state) => {
        // SET CURRENT ITEM CHILDREN
        if ((
          mutation.type === 'standardItems/itemTypes/children/SET_ITEM_TYPE_CHILDREN' ||
          mutation.type === 'standardItems/itemTypes/children/UPDATE_ITEM_TYPE_CHILDREN' ||
          mutation.type === 'standardItems/itemTypes/children/DELETE_ITEM_TYPE_CHILDREN') &&
          mutation.payload.typeChildren.id === this.type.id
        ) {
          console.log('SUBSCRIBE CHILDREN FOR BRANCH', this.type.id)
          console.log('mutation IS SET CURRENT ITEM TYPE')
          console.log('mutation', mutation)
          const children = this.getChildrenForType(this.type.id)
          console.log('children: ', children)
          this.children = children
        }
      })

      if (!this.subscribed) this.subscribed = true
    },
    /*
    routeToItems (e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }

      console.log('route to item type: ', this.type)
      if (!this.isFolder) {
        const location = `/standard-items/${this.type.id}/items`
        // console.log('routing to location: ', location)
        this.$router.push(location)
      } else {
        // If it's a folder with more subtypes, route to a Type Tree that starts at this Type
        const location = `/standard-items/${this.type.id}`
        // console.log('routing to location: ', location)
        this.$router.push(location)
      }
    },
    */
    showEdit (e) {
      e.stopPropagation()
      e.preventDefault()
      this.newName = this.type.name
      this.showInput = true
      // console.log('edit on component: ', this)
      this.$nextTick(function () {
        // console.log() // => 'updated'
        this.$el.querySelector('input').focus()
      })
    },
    deleteOpen (e) {
      e.stopPropagation()
      e.preventDefault()
      // this.$store.dispatch('itemTypes/deleteOpen', { itemType: this.type })
      this.deleteDialog = true
    },
    deleteCancel () {
      this.deleteDialog = false
      this.deleteChildrenOnly = false
    },
    async confirmDelete () {
      // console.log('delete confirmed')
      // console.log('type: ', this.type)
      this.deleteDialog = false
      this.loading = true
      console.log('this.deleteChildrenOnly', this.deleteChildrenOnly)
      const result = await this.remove({ id: this.type.id, childrenOnly: this.deleteChildrenOnly })

      if (result === 'deleted') {
        console.log('delete complete')
      } else {
        console.log('result error: ', result)
      }

      this.$emit('update')
      this.deleteChildrenOnly = false
      this.loading = false
    },
    clickedInput (e) {
      console.log('clicked input', e)
      e.stopPropagation()
      e.preventDefault()

      //
    },
    async saveEdit (e) {
      e.stopPropagation()
      e.preventDefault()

      if (this.type.name === this.newName) {
        this.showInput = false
      }

      // console.log('SAVING NEW TYPE NAME')
      if (this.type.name !== this.newName && this.newName.length > 0) {
        this.showInput = false
        this.loading = true
        const updateResult = await this.updateItemType({
          id: this.type.id,
          update: { name: this.newName }
        })
        if (updateResult === 'success') {
          this.$emit('update')
        }
        // console.log('updateResult: ', updateResult)
      }
      this.showInput = false
      this.loading = false
    },
    cancel (e) {
      e.stopPropagation()
      e.preventDefault()
      this.showInput = false
    },
    headerClick (e) {
      // /*
      console.log('BRANCH CLICK EVENT: ', e)
      console.log('this: ', this)
      console.log('name: ', this.name)
      console.log('this.isFolder', this.isFolder)
      console.log('this.open', this.open)
      console.log('this.editMode', this.editMode)
      // */
      e.stopPropagation()
      e.preventDefault()

      // Toggle Event
      if (this.isFolder) {
        this.open = !this.open
      } else if (this.editMode) {
        this.updateSelected(this.type.id)
      } else if (this.selectable && !e.path.some(node => node.classList && node.classList.contains('branch__selected'))) {
        this.updateSelected(this.type.id)
      } else if (this.$vuetify.breakpoint.lgAndDown) {
        this.$router.push(this.routeToItems)
      }
    },
    changeType (e) {
      e.stopPropagation()
      e.preventDefault()

      if (!this.isFolder) {
        this.addChild()
        this.open = true
        this.showInput = false
      } else {
        this.deleteChildrenOnly = true
        this.deleteDialog = true
      }
    },

    hideNewChildInput (e) {
      e.stopPropagation()
      e.preventDefault()

      this.showNewChildInput = false
    },
    openNewChildInput (e) {
      e.stopPropagation()
      e.preventDefault()
      // console.log('add new child', e)
      this.showNewChildInput = true

      this.$nextTick(function () {
        this.$el.querySelector(`#new-child-input-${this.type.id}`).select()
      })
    },
    newChildInput (e) {
      this.newChild = e
    },

    newChildKeyInput (e) {
      // console.log('newChildKeyInput', e)
      // Abort if the element emitting the event is not
      // the element the event is bound to
      if (e.target !== e.currentTarget) return
      if (e.keyCode !== 13) return

      this.saveNewChild(e)
    },

    saveNewChild (e) {
      e.stopPropagation()
      e.preventDefault()

      if (this.newChild &&
        // this.newChild !== 'New Type' &&
        this.newChild.trim().length) {
        this.addChild()
      }
    },

    async addChild () {
      this.showNewChildInput = false
      this.loading = true
      const result = await this.create({
        parent: this.type,
        newType: {
          name: this.newChild
        }
      })
      console.log('result: ', result)
      this.getChildren()
      this.newChild = 'New Type'
      this.loading = false
    },
    ...mapActions('standardItems/itemTypes', {
      create: 'create',
      remove: 'remove',
      updateItemType: 'update',
      updateSelected: 'updateSelected'
    })
  },
  render (h) {
    const icon = this.isFolder ? (
      <v-btn
        small
        class={this.iconBtnClasses}
        style={{ minWidth: '28px' }}
        icon
        loading={this.loading}
        onNativeClick={this.headerClick} // TODO: native.stop
        //   onDoubleClick={this.toggle}
      >
        <v-icon small>{ this.open ? 'mdi-chevron-down' : 'mdi-chevron-right' }</v-icon>
      </v-btn>
    ) : this.selectable ? (
      <v-checkbox
        class="branch__selected"
        inputValue={this.isSelected}
        onChange={this.branchCheckboxChanged}
        hideDetails
      >
      </v-checkbox>
    ) : this.editMode ? (
      <v-btn
        v-show={!this.showInput}
        class={this.iconBtnClasses}
        style={{ minWidth: '28px' }}
        small
        icon
        onClick={this.routeToItems}
        loading={this.loading}
      >
        <v-icon color="primary" small>mdi-open-in-new</v-icon>
      </v-btn>
    ) : (
      <v-btn
        class={this.iconBtnClasses}
        style={{ minWidth: '28px' }}
        small
        icon
        loading={this.loading}
      >
        <v-icon color="primary" small>mdi-open-in-new</v-icon>
      </v-btn>
    )

    const itemCount = this.itemCount && this.itemCount > 0 ? (
      <span
        class="ml-1 caption grey--text"
      >({this.itemCount})</span>
    ) : null

    const changeTypeBtn = this.$can('create', 'types') && this.editMode
      ? this.isFolder
        ? (
          <v-tooltip
            bottom
          >
            <v-btn
              onClick={this.changeType}
              slot="activator"
              class="hover-btn"
              small
              icon
            >
              <v-icon>mdi-folder-remove</v-icon>
            </v-btn>
            <span>Remove all Child Types</span>
          </v-tooltip>
        ) : (
          <v-tooltip
            bottom
          >
            <v-btn
              onClick={this.changeType} // TODO: .stop
              slot="activator"
              class="hover-btn"
              small
              icon
            >
              <v-icon>mdi-folder-open</v-icon>
            </v-btn>
            <span>Create Child Types</span>
          </v-tooltip>
        ) : null

    const editBtn = this.$can('update', 'types') && this.editMode && (
      <v-btn
        small
        icon
        class="hover-btn"
        onClick={this.showEdit} // TODO: native.stop
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    )

    const deleteBtn = this.$can('delete', 'types') && this.editMode && (
      <v-btn
        small
        icon
        class="hover-btn"
        onClick={this.deleteOpen} // TODO: native.stop
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    )

    const editInput = this.$can('update', 'types') && this.editMode && (
      <v-flex
        class="inline-input"
        v-show={this.showInput}
      >
        <v-text-field
          onInput={this.inputNewName}
          onKeyup={this.updateNameKeyInput}
          value={this.newName}
          class={{ 'input-group--focused': this.showInput }}
          single-line
          hide-details
          solo
          light
          // TODO: @keyup.enter="saveEdit"
          onClick={this.clickedInput} // TODO: native.stop
        ></v-text-field>
        {itemCount}

        <v-spacer/>

        <v-btn small icon
          onClick={this.saveEdit} // TODO: native.stop
          class="ml-0"
        >
          <v-icon color="success">mdi-check</v-icon>
        </v-btn>

        <v-btn small icon
          onClick={this.cancel} // TODO: native.stop
          class="ml-0"
        >
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </v-flex>
    )

    const branches = this.isFolder && this.children && this.sortedChildren.map(child => (
      <TreeBranch
        class="item"
        // id="type.id"
        editMode={this.editMode}
        type={child}
        parents={this.parentsForChildren}
        onUpdate={this.update}
        expandAll={this.expandAll}
        collapseAll={this.collapseAll}
        pagination={this.pagination}
        headers={this.headers}
        dense={this.dense}
        onSearchMatch={this.childSearchMatch}
        search={this.search}
        key={child.id}
        selectable={this.selectable}
        selectedType={this.selectedType}
      />
    ))

    const newChildInputRow = this.$can('create', 'types') && this.editMode && (
      <li
        v-show={!this.loading}
        class={{
          'item-header': true,
          'dense': this.dense
        }}
        onClick={this.openNewChildInput}
      >
        <div
          v-show={this.showNewChildInput}
          class="inline-input new-child-input"
        >
          <v-text-field
            onInput={this.newChildInput}
            value={this.newChild}
            class={{ 'input-group--focused': this.showNewChildInput }}
            id={`new-child-input-${this.type.id}`}
            single-line
            hide-details
            solo
            light
            onKeyup={this.newChildKeyInput}
            // @keyup.enter="saveNewChild"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn
            small
            icon
            onClick={this.saveNewChild}
          >
            <v-icon color="success">mdi-check</v-icon>
          </v-btn>

          <v-btn small icon
            class="ml-0"
            onClick={this.hideNewChildInput}
          >
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-btn
          small
          icon
          v-show={!this.showNewChildInput}
          onClick={this.openNewChildInput}
          onKeyup={this.openNewChildInput}
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </li>
    )

    const childTypesList = this.isFolder && (
      <ul
        v-show={this.open}
        class={{
          'sub-list': true,
          'sub-list--dense': this.dense
        }}
      >
        {branches}
        {newChildInputRow}
      </ul>
    )

    const deleteMessage = this.deleteChildrenOnly
      ? (
        <v-card-text>This will permanently delete:
          <div class="mx-1">Any <span class="body-2 mx-1 warning--text nowrap">Sub Types</span> of {this.type.name}</div>
          <div class="mx-1">and<span class="body-2 error--text mx-1 nowrap">ALL STANDARD ITEMS</span>
          associated with this Type.</div></v-card-text>
      ) : (
        <v-card-text>This will permanently delete:
          <div class="mx-1">The <span class="body-2 mx-1 warning--text nowrap">{this.type.name}</span> Type</div>
          <div class="mx-1">Any <span class="body-2 mx-1 warning--text nowrap">Sub Types</span> of {this.type.name}</div>
          <div class="mx-1">and<span class="body-2 error--text mx-1 nowrap">ALL STANDARD ITEMS</span>
          associated with this Type.</div></v-card-text>
      )

    const headerElment = this.isFolder ||
    this.editMode
      ? (
        <div
          class={{
            'item-header': true,
            'item-header--dense': this.dense,
            'leaf': !this.isFolder,
            'branch--selectable': this.selectable
          }}
          onClick={this.headerClick}
        >
          {icon}

          <v-flex
            v-show={!this.showInput}
            class="inline-header"
          >
            <span>{this.type.name}</span>
            {itemCount}

            <v-spacer/>
            {changeTypeBtn}

            {editBtn}
            {deleteBtn}
          </v-flex>
          {editInput}
        </div>
      ) : (
        <router-link
          class={{
            'item-header': true,
            'item-header--dense': this.dense,
            'leaf': !this.isFolder,
            'branch--selectable': this.selectable
          }}
          to={this.routeToItems}
        >
          {icon}

          <v-flex
            v-show={!this.showInput}
            class="inline-header"
          >
            <span>{this.type.name}</span>
            {itemCount}

            <v-spacer/>
          </v-flex>
        </router-link>
      )

    return (
      <li
        v-show={this.deepSearchMatch}
      >
        {headerElment}

        {childTypesList}

        <DeleteModal
          deleteDialog={this.deleteDialog}
          onClose={this.deleteCancel}
          onConfirmDelete={this.confirmDelete}
          scopedSlots={{
            message: scope => deleteMessage
          }
          }
        />
      </li>
    )
  }
}
</script>

<style lang="stylus">
.branch__selected
  .v-input__slot
    margin-bottom: 0

</style>
